@if(searchParams$ | async; as params){
    <h2>Fel vid hämtning av kontrakt</h2>
    @if(params.kontraktnummer){
        Det finns inget kontrakt med kontraktnummer <b>{{params.kontraktnummer}}</b>
    }
    @else if(params.atgardBeteckning){
        Det finns inget kontrakt kopplat till en atgärd med beteckning <b>{{params.atgardBeteckning}}</b>
    }
    @else{
        Antingen kontraktnummer eller åtgärdsbeteckning måste anges
    }
}